import BackgroundImage from 'assets/images/first-place-bg.png'

import { FC } from 'react';
import ResultItem from './ResultItem';
import IResult from 'models/Result';
import { v4 } from 'uuid';

type Props = {
  results: IResult[];
}

const ResultsList:FC<Props> = ({ results }) => {
  return (
    <div
      className="relative overflow-hidden border-2 rounded-3xl w-full h-full mt-4 mb-4 pt-6 xl:mt-24 xl:mb-0"
      style={{ 
        borderColor: 'rgba(255,255,255,0.6)',
        background: `linear-gradient(0deg, rgba(0,0,0,0.5), rgba(0,0,0,0.5)), url(${BackgroundImage}) left / contain no-repeat`  }}
    >
      {results.map((result) => (
        <ResultItem key={v4()} result={result} />
      ))}
    </div>
  )
}

export default ResultsList;
